/**
 * ConfirmSubmit
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Alert, ListGroup } from 'react-bootstrap';
import PrimaryAction from 'components/interaction/PrimaryAction/index.jsx';
import Spinner from 'components/Spinner/index.jsx';
import messages from './messages.js';
import useMatchusers from '../../useMatchUsers.js';

function emailAddresses(row) {
  return Object.keys(row)
    .filter((key) => key.startsWith('email'))
    .map((key) => row[key])
    .filter(Boolean)
    .join(', ');
}

function ConfirmSubmit(props) {
  const { roleName, users, onClose, onSubmit, emailFields } = props;
  const { matched, unmatched, working } = useMatchusers(users, roleName);
  if (working) {
    return <Spinner />;
  }

  function handleSubmit() {
    onSubmit(matched.map((o) => ({
      userId: o.id,
      email: Array.isArray(emailFields) ? emailFields.map((f) => o[f]).filter(Boolean) : o[emailFields],
    }))).then(() => {
      if (onClose) {
        onClose();
      }
    });
  }

  const namesNotFound = { ...messages.namesNotFound, values: { roleName } };
  const namesFound = matched.length === 0 ? messages.noNamesFound : {
    ...messages.namesFound,
    values: { count: matched.length, remaining: unmatched.length > 0 },
  };
  return (
    <>
      {unmatched.length > 0 && (
        <>
          <Alert variant="warning" className="mt-5"><FormattedMessage {...namesNotFound} /></Alert>
          <ListGroup>
            {unmatched.map((row) => (
              <ListGroup.Item key={JSON.stringify(row)} className="d-flex">
                <span className="flex-grow-1">{row.searchString}</span>
                <span className="text-end">{emailAddresses(row)}</span>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </>
      )}
      <Alert variant="info" className="mt-5"><FormattedMessage {...namesFound} /></Alert>
      <PrimaryAction onCancel={onClose} onSubmit={handleSubmit} submitText={messages.sendInvitations} valid={matched.length > 0} />
    </>
  );
}

ConfirmSubmit.propTypes = {
  roleName: PropTypes.string.isRequired,
  users: PropTypes.array.isRequired,
  emailFields: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConfirmSubmit;
